import { TOAST_TYPES } from './toastTypes';

export const TOAST_ICONS = {
	[TOAST_TYPES.INFO]: 'ℹ️',
	[TOAST_TYPES.SUCCESS]: '✅',
	[TOAST_TYPES.WARNING]: '⚠️',
	[TOAST_TYPES.ERROR]: '❌',
	[TOAST_TYPES.SECURITY]: '🔒',
	[TOAST_TYPES.NEUTRAL]: '📝',
	[TOAST_TYPES.LOADING]: '⏳',
	[TOAST_TYPES.DELETED]: '🗑️',
	[TOAST_TYPES.COPIED]: '📋',
	[TOAST_TYPES.SENT]: '📤',
	[TOAST_TYPES.LOCKED]: '🔐',
	[TOAST_TYPES.OFFLINE]: '🔌',
	[TOAST_TYPES.ONLINE]: '📡',
	[TOAST_TYPES.CANCELLED]: '✂️',
	[TOAST_TYPES.DEACTIVATED]: '🚫',
	[TOAST_TYPES.ASSIGNED]: '🎁',
	[TOAST_TYPES.PERMISSION]: '🔑',
	[TOAST_TYPES.TOPUP]: '💰',
	[TOAST_TYPES.CARD]: '💳',
};
